<script lang="ts">
  /**
   * GridInner - Inner content wrapper for card areas within GridContent.
   *
   * Provides consistent inset from grid lines on large screens.
   * This creates the inner "card zone" spacing seen in the Figma designs.
   * Use inside GridContent when you have card layouts that need the inner inset.
   *
   * Sizes:
   * - "default" (54px) = 45px visual gap + 9px half-star centering offset
   * - "small" (27px) = half size for denser grids
   */
  import type { Snippet } from 'svelte';

  interface Props {
    class?: string;
    /** Size variant: "default" (54px) or "small" (27px) */
    size?: 'default' | 'small';
    children?: Snippet;
  }

  let { class: className = '', size = 'default', children }: Props = $props();

  const padding = $derived(size === 'small' ? '27px' : '54px');
</script>

<div class="lg:px-(--grid-inner-padding) {className}" style="--grid-inner-padding: {padding}">
  {#if children}
    {@render children()}
  {/if}
</div>
